import BotTagLists from "containers/SaasModern/BotPage/BotTagLists/BotTagLists";
import BotLists from "../BotLists";
import { useEffect, useState } from "react";
import { Mixpanel } from "utils/mixpanel";

const BotsCategory = ({ context }) => {
  const [aiStoreData, setAiStoreData] = useState(context?.aiStoreData);

  const onItemClick = (e, slug) => {
    Mixpanel.track("Landing Page - AI Store - Tag click", {
      tag: slug,
    });

    //e.preventDefault();
    if (slug == "all") {
      setAiStoreData(context?.aiStoreData);
    } else {
      const filteredData = context?.aiStoreData?.filter(
        (bot) => bot.tag_slug == slug
      );
      setAiStoreData(filteredData);
    }
  };
  useEffect(() => {
    setAiStoreData(
      context?.aiStoreData?.filter((bot) => bot.tag_slug === "news")
    );
  }, [context?.aiStoreData]);
  return (
    <div style={{ width: "100%" }}>
      <BotTagLists
        botTagsData={context.botTagsData}
        onItemClick={onItemClick}
      />
      <div>
        {aiStoreData?.map((bot) => (
          <BotLists bots={bot.bots} tagName={bot.tag_name} />
        ))}
      </div>
    </div>
  );
};
export default BotsCategory;
